export const attributeKey = {
  simulationName: "sim_name",
  vrModule: "vr_module",
  documentType: "document_type",
  industry: "industry",
};

// Registry of every available document filter. PRODUCT_TABS entries reference
// these by key to declare which filters a product shows (see index.jsx).
//   key        — the filter field name on the filters object
//   component  — "dropdown" (DropdownFilter) | "documents" (DocumentsDropdownFilter)
//   dataKey    — field on getFiltersData() output that feeds the options
//   trackName  — event name passed to trackFilterEvent
//   trackValue — maps the selected option to the tracked value
export const FILTER_DEFINITIONS = {
  activity: {
    key: "activity",
    component: "dropdown",
    dataKey: "activities",
    trackName: "activity",
    trackValue: (value) => value?.name,
  },
  industry: {
    key: "industry",
    component: "documents",
    dataKey: "industries",
    className: "documents-industry-filter",
    placeholder: "industry",
    trackName: "industry",
    trackValue: (value) => value,
  },
  simulation: {
    key: "simulation",
    component: "documents",
    dataKey: "simulations",
    className: "documents-simulation-filter",
    placeholder: "simulations",
    trackName: "simulation",
    trackValue: (value) => value,
  },
  estimatedTime: {
    key: "estimatedTime",
    component: "documents",
    dataKey: "estimatedTimes",
    className: "documents-estimated-time-filter",
    placeholder: "estimated time",
    formatter: (estimatedTime) =>
      estimatedTime ? `${estimatedTime} min` : estimatedTime,
    trackName: "estimated_times",
    trackValue: (value) => value,
  },
};
